import moment from 'moment'
import React, { Component } from 'react'

export default class ReportTitle extends Component {
  render() {

    const rp = this.props.report

    const reportMonth = moment(`${rp.year}-${String(rp.month+1).padStart(2, '0')}-01 00:00:00`).format('MMMM')

    return (
      <div className="container sie-title-container">
        <h4 className="title">Relatório {rp.operatorName || 'Geral'}</h4>
        <h5 className="subtitle" style={{fontWeight: 'bold'}}>
          <span style={{textTransform: 'capitalize'}} >{reportMonth}</span> de {rp.year}
        </h5>
      </div>
    )
  }
}
